import { Route, Routes } from 'react-router';

import ProfilePage from './_pages/ProfilePage';
import UpdatePasswordPage from './_pages/UpdatePasswordPage';

export const ProfileRoutes = () => {
  return (
    <Routes>
      <Route index element={<ProfilePage />} />
      <Route path="/password" element={<UpdatePasswordPage />} />
    </Routes>
  );
};
